import dayjs from 'dayjs';
import Resources from '../../../../helpers/resources';

export const ACADEMIC_YEAR_RETRIEVED = 'ACADEMIC_YEAR_RETRIEVED';

function getAcademicYear() {
    return (dispatch) =>
        Resources.academicYear
            .get()
            .send()
            .then((payload) =>
                dispatch({
                    type: ACADEMIC_YEAR_RETRIEVED,
                    payload: getFormattedAcademicYear(payload)
                })
            );
}

function getFormattedAcademicYear(payload) {
    const { year, startDateDateTime, endDateDateTime } = payload.data;
    const formatString = 'YYYY-MM-DD';
    return {
        year,
        startDate: dayjs(stripTime(startDateDateTime)).format(formatString),
        endDate: dayjs(stripTime(endDateDateTime)).format(formatString)
    };
}

function stripTime(isoString) {
    return isoString.split('T')[0];
}

export default {
    getAcademicYear
};



// WEBPACK FOOTER //
// ./components/report-filters/redux/academic-year/academic-year-actions.js